export function getDefaultHeaderLogo(){
 $('.scheduler-modal .header-brand-logo').attr('src', $(".header-classic .logo-sec .navbar-brand img").attr("src"));
}